import React from "react";

const Artists = () => {

    return(
        <div style={{
            display:"flex",
            alignItems:"center",
            justifyContent:"center",
            width:"100%"
        }}>
           
           <h2>Artists</h2>
          

        </div>
    )
}

export default Artists